(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !window.DesignMode) return;
  try {
    
jQuery(document).ready(function ($) {
  let carousel = $('.carousel')
  let interval = carousel.attr('data-interval')


  if (interval > 0) {
    let carousel = $('.carousel')
    let interval = carousel.attr('data-interval')

    if (interval > 0) {
      let width = 0
      let paused = false
      let stopped = false

      let startInterval = setInterval(function handleInterval() {
        if (!paused)
          width++

        $(carousel.find('.carousel-progress-bar')).css('width', width * (1000 / interval) + '%')
      }, 10);

      carousel.on('slide.bs.carousel', function () {
        if (!stopped) {
          width = 0
          paused = false
        }
      })

      carousel.hover(
        function() {
          paused = true
        },
        function() {
          if (!stopped) {
            paused = false
            width = 0
          }
        }
      )

      $(carousel.find('.carousel-autoplay-btn')).click(function () {
        if ($(this).hasClass('is-playing')) {
          $(this)
            .removeClass('is-playing')
            .addClass('is-paused')
            .attr('aria-label', $(this).attr('data-label-play'))
          carousel.find('.carousel-inner').attr('aria-live', 'polite')
          paused = true
          stopped = true
          carousel.carousel('pause')
        } else {
          $(this)
            .removeClass('is-paused')
            .addClass('is-playing')
            .attr('aria-label', $(this).attr('data-label-stop'))
          carousel.find('.carousel-inner').attr('aria-live', 'off')
          paused = false
          stopped = false
          width = 0
          carousel.carousel('cycle')
        }
      })

    }

  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    
jQuery(document).ready(function ($) {

  // Sticky summary
  let header = $('#shopify-section-header')
  let top = 20

  if($(header).css('position') == 'sticky') {
    top += header.outerHeight()
  }

  $('.sticky-cart-summary').css({
    'position': 'sticky',
    'top': top,
    'z-index': 1019
  })

})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

jQuery(document).ready(function ($) {

  //Mini Cart on hover
    function toggleNavbarMethod() {  
        if ($(window).width() <= 1024) {  
            $('#cart-header').on('touchstart', function(e){ 
             // console.log("clickon");
              e.preventDefault();
                //$('#cart-icon', this).trigger('click');   
                //alert($('#cart-icon').attr('href'));
                window.location.href = $('#cart-icon').attr('href');
            }).on('touchend', function(){  
              //console.log("clickoff");
                //$('#cart-icon', this).trigger('click').blur();  
            });  
        }  
        else {  
            $('#cart-header').off('touchstart').off('touchend');  
        }  
    }  
    toggleNavbarMethod();  
    $(window).resize(toggleNavbarMethod); 
     


  // Autofocus search input
  //$('#navbar-search').on('shown.bs.dropdown', function(e) {
  //  $('#navbar-search input[type=search]').focus()
  //})


})

  

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !window.DesignMode) return;
  try {
    
  // Newsletter ajax form
  // jQuery(document).ready(function ($) {
  //  $('form#newsletter-form').submit(function(e) {
  //   e.preventDefault()
  //    jQuery.post('/contact', $(this).serialize(), function(data) {
  //      console.log(data)
  //    })
  //   })
  // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
      //<script>
       // jQuery(document).ready(function($){
       //   var title_text = $('.product-title-main').text();
       //   var title_text_r = $('#original-product-title').html();
        //  console.log(title_text);
       //   console.log(title_text_r);
       //   $('#soriginal-product-title').text(title_text);
       //   // console.log(title_text);
       // });
      //</script>
      
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read base URL from data attribute
      var baseUrl = productRecommendationsSection.dataset.baseUrl;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      // Test that its working
      // console.log(`Product id: ${productId}, baseUrl: ${baseUrl}, limit: ${limit}`)
      // Build request URL
      var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        }

        // Fix native lazy loading
        if ('loading' in HTMLImageElement.prototype) {
          const images = document.querySelectorAll('img[loading="lazy"]')
          images.forEach(img => {
            img.src = img.dataset.src
          })
        } 
        
        //Change the title of the recommendation block
        var product_title_obj = document.getElementsByClassName("product-title-main");
        for (var i = 0; i < product_title_obj.length; i++) {
         var product_title = product_title_obj[i].innerText;
          document.getElementById("original-product-text").textContent = product_title;
        }

        //TOFIX - get dynamic yotpo on recommendation products
        /*if (typeof yotpo == 'undefined') {
          var yotpo = new Yotpo("iAJtEvBfRkifLYe0pUS1yiRjKpWsg69l5L3jgcU8", {"account_settings":{"settings":{"customer_language":"en","account_logo":"https://cdn-yotpo-images-production.yotpo.com/Account/318783/89166586/thumb.jpg?1602760092","domain":"shop.bullymax.com","name":"https://shop.bullymax.com","auto_publish":true}},"reviews":false,"testimonials":{"settings":{"default_tab":"product_tab","show_tab":"both","display_free_text_filters":false}},"testimonials_tab":{"settings":{"floater_position":"left","label":"Reviews","header_text":"","floater_opacity":1.0,"floater_text_color":"#fefefe","floater_background":"#000000"}},"questions_and_answers":false,"questions_and_answers_standalone":false,"vendor_review_creation":false,"language":"en","comments":{"settings":{"comments_visibility":"1"}},"async_create":{"settings":{}},"ads":{"settings":{}},"facebook_ads":{"settings":{"pixel_id":"0","init_pixel":"1","page_view":"1","purchase":"1"}},"show_social_links":false,"host":"static","css_custom_host":null,"direction":"ltr","reporting_end_points":["p.yotpo.com"],"close_button":false,"version":"2021-02-28_22-44-38","prevent_duplicate_reviews":false,"custom_fields_info":{},"widget_rich_snippet":{"settings":{}},"carousel_settings":{"settings":{}},"review_with_pictures":{"settings":{"main_widget_visible":"1","testimonials_visible":"1","number_of_pictures_per_review":10,"collection_enabled":true}},"visual_curation":false,"visual_carousel":false,"pictures_slider":false,"pictures_dedicated_page":false,"generic_gallery":false,"product_gallery":false,"shoppable_instagram":false,"load_only_widgets_on_page":false,"load_css_async":false,"ab_testing":false,"cookie_path":false,"upload_photos":false,"upload_videos":false,"video_support":{"settings":{"partner_id":"2651991","player_id":44988261,"ks":"djJ8MjY1MTk5MXwrG0HmF_aMHF_-c8ej6sDGffQxroIQyDd_flT-6U0s-I8FyIAAJL7xwDVEMM-0xNE7IPsl-62_Qg49TdDW04yz","metadata_profile_id":12436091,"player_version":"1.0.3"}},"new_main_widget_layout":false,"new_testimonials_widget_layout":false,"shoppers_say":{"settings":{"show":true,"title":"REVIEW HIGHLIGHTS","max_sentences_desktop":2,"max_sentences_mobile":1,"widget_font":"Open Sans","text_theme":"Dark","background_color":{"transparent":false,"color":"#E8F6FF"},"links_color":"#0084e9","stars_color":"#e7721b","text_colors":{"primary_color":"#051146","name_color":"#697090","more_reviews_link_color":"#37416b","more_reviews_links_hover":"#50587e"},"arrow_colors":{"color":"#0084e9","hover_color":"#0077d2"}}},"widget_v2":{"settings":{"read_only":"0","redis_cache_expires_in":"300","http_cache_expires_in":10800,"review_per_page":"5","date_format":"%m/%d/%y","reporting_domains":["p.yotpo.com"],"close_button":"0","version":null,"css_custom_host":null,"show_average_rating_digits":false,"display_vote_text":"0","disable_yotpo_logo_hyperlink":"0","display_crf_filters":false,"display_topic_filters":false,"better_performance_effective_date":"2020-09-15","display_free_text_filters":false,"reviews_display_names":{"order_properties":null,"order_custom_properties":null,"order_product_properties":null,"order_product_custom_properties":null,"product_properties":null,"product_specs_properties":null,"customer_properties":null,"customer_custom_properties":null},"display_orders_filters":false,"display_names":{"order_properties":null,"order_custom_properties":null,"order_product_properties":null,"order_product_custom_properties":null,"product_properties":null,"product_specs_properties":null,"customer_properties":null,"customer_custom_properties":null},"fetch_from_elastic":false,"disable_performance_section":true,"use_new_filter_and_search_outbound_service":false,"display_star_distribution":false}},"ticker":false,"lightbox_new_design":false,"gallery_customizations":false,"add_to_cart":false,"bv_syndication":false,"disable_social_login":false,"gremlins_dev":false,"grid_layout":false,"carousel_layout":false,"collage_layout":false,"widgets_data_requests":{"settings":{}},"disable_shopper_side_cookies":false});
          Yotpo.ready(function() {
              yotpo.init();
          });
        }*/
      };
      request.send();
    };

    // Listen for changes done in the Theme Editor
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations") {
        loadProductRecommendationsIntoSection();
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();
  
  } catch(e) { console.error(e); }
})();
})();
